// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__24gvx","row":"ProcedureTreatmentSummary_row__3Ez9f"};